export const handleEloquaForms = (enableEloquaTestEmails: boolean, logger?: Console) => {
  const formArray: NodeListOf<HTMLFormElement> = document.querySelectorAll(
    '[action="https://s1399.t.eloqua.com/e/f2"]',
  );
  formArray.forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event?.preventDefault();
      const data = new FormData(form);
      const siteId = data.get('elqSiteId') as string;
      try {
        const token = await fetch(`https://s1399.t.eloqua.com/e/formsubmittoken?elqSiteID=${siteId}`).then((response) =>
          response.text(),
        );

        // set dynamic fields - will overwrite what is in the form already
        data.set('FormLocation', location.pathname);
        data.set('PageName', document.querySelector('h1')?.textContent ?? document.title);
        data.set('elqFormSubmissionToken', token);
        if (enableEloquaTestEmails) {
          data.set('TestEnvironment', 'true');
        }

        const response = await fetch(form.action, { method: 'post', body: data });
        if (response.status === 200) {
          const successAlert = form.parentNode?.querySelector('leaf-alert[type="success"]');
          form.setAttribute('hidden', 'true');
          successAlert?.setAttribute('open', 'true');
        } else {
          throw new Error(`Fetch response: ${response}`);
        }
      } catch (error) {
        logger?.warn(`Error submitting Eloqua form: ${error}`);
        const errorAlert = form.parentNode?.querySelector('leaf-alert[type="error"]');
        form.setAttribute('hidden', 'true');
        errorAlert?.setAttribute('open', 'true');
      }
    });
  });
};
